<div [class.show]="show" class="loader-overlay step">
  <img class="logo-image" [src]="'assets/main-logo.svg'"
       alt="Cardea Commerce Loader">
</div>
